export const getEnumKeyByValue = <T extends Record<string, string>>(enumObj: T, value: string): string | undefined =>
    Object.keys(enumObj).find(key => enumObj[key] === value);
